/**
 * Created by lari on 12/06/2017.
 */
(function () {
    'use strict';
    /**
     * @ngdoc service
     * @name reminder.factory:ReminderService
     *
     * @description
     *
     */
    angular
        .module('vcreminder')
        .factory('Reminder', Reminder)
        .config(config);


    config.$inject = ['restmodProvider'];

    function config(restmodProvider) {
        restmodProvider.rebase({
            $config: {
                primaryKey: '_id'
            }
        });
    }


    Reminder.$inject = ['restmod'];

    function Reminder(restmod) {
        return restmod.model('/routes/reminders').mix({
            created: {
                init: function () {
                    return moment().toISOString();
                }
            },
            active: {init: true},
            $extend: {
                Model: {
                    $searchahead: function (_params) {
                        return this.$collection().$decorate({
                            'before-request': function (_req) {
                                _req.method = 'GET';
                                _req.url = '/routes/reminders/searchahead';
                            }
                        }, function () {
                            return this.$fetch(_params);
                        });
                    },
                  $searchBy: function (key, val) {
                    let realquery = {};
                    realquery[key] = val;
                    return this.$search(realquery);
                  }
                } // Model
            }// extend
        });
    }


    // Klammerfriedhof
}());
